// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2gQDy","ranges":"BmiRanges_ranges__17BYj"};